import { render } from "./SetSuccess.vue?vue&type=template&id=2519fc0c"
import script from "./SetSuccess.vue?vue&type=script&lang=js"
export * from "./SetSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__